export default () => {
    return (
        <div className="status enjoy">
            <div className="line"></div>
            <span>ENJOY THE<br/>ROLL!</span>
        </div>
    )
}